import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=3c91dd2c&scoped=true&"
import script from "./NotificationBar.vue?vue&type=script&lang=js&"
export * from "./NotificationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c91dd2c",
  null
  
)

export default component.exports